// Utils
import moment from 'moment'

// Constants
import DRIVER_CONSTANTS from '@/constants/driverConstants'

export function getDate(date) {
  let format = 'HH:mm'
  const _date = moment(date).hours(0).minutes(0).seconds(0).milliseconds(0)
  const currentDate = moment().hours(0).minutes(0).seconds(0).milliseconds(0)
  if (Math.abs(_date.diff(currentDate, 'days')) >= 1) {
    format = 'dddd, MMMM Do YYYY, HH:mm'
  }
  return moment(date).locale('es').format(format)
}

// Notification functions
export function requestNotificationPermission() {
  if ('Notification' in window) {
    window.Notification.requestPermission(function(status) {
      if (process.env.NODE_ENV === 'development') {
        console.log(`Permission ${status}`)
      }
    })
  }
}

export function sendNotification(message) {
  if ('Notification' in window) {
    try {
      const options = {
        icon: '/img/logo.png'
      }
      window.Notification.requestPermission(function(status) {
        if (status === 'granted') {
          new window.Notification(message, options)
        }
      })
    } catch (err) {
      alert(message)
      console.log(err)
    }
  }
}

export function moneyFormat(value) {
  return `$${value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

export function isMobile() {
  let isMobile = false
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true
  }
  return isMobile
}

export function isIOSMobile() {
  let isMobile = false
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    isMobile = true
  }
  return isMobile
}

export function isAndroidMobile() {
  let isMobile = false
  if (/Android/i.test(navigator.userAgent)) {
    isMobile = true
  }
  return isMobile
}

export function getDriverAssignationAction(data, order) {
  let payload
  const deliveryMan = order.deliveryMan
  if (!data.driver && deliveryMan && deliveryMan._id) {
    payload = DRIVER_CONSTANTS.DRIVER_ASSIGNATION_ACTIONS.DRIVER_REMOVED
  } else if (deliveryMan && (data.driver !== deliveryMan._id) && deliveryMan._id) {
    payload = DRIVER_CONSTANTS.DRIVER_ASSIGNATION_ACTIONS.DRIVER_CHANGED
  }
  return payload
}

export function customerName(order) {
  let customerCapitalized = ''
  if (order.customer && order.customer.firstName) {
    const customerName = order.customer.firstName.toLowerCase()
    customerCapitalized = customerName.charAt(0).toUpperCase() + customerName.slice(1)
  }
  return customerCapitalized
}

export function stringToBoolean(str) {
  let isBoolean = false
  if (str) {
    if (Array.isArray(str) && str.length) {
      isBoolean = (/true/i).test(str[0].value)
    } else {
      isBoolean = (/true/i).test(str)
    }
  }
  return isBoolean
}
